import Vue from "vue";
import DrxBanner, { isBannerActive, data } from "./";

window.addEventListener("DOMContentLoaded", async () => {
  const mountingElement = document.getElementById("navbar-drx-banner");

  if (!mountingElement) {
    return;
  }

  if (!isBannerActive()) {
    return;
  }

  new Vue({
    el: "#navbar-drx-banner",
    render: function (createElement) {
      return createElement(DrxBanner, { props: { data: data } });
    },
  });
});
